type SafetyRegion = {
  [key: string]: string;
};

type VehicleType = {
  [key: string]: string;
};

type SpecialCases = {
  [key: string]: string;
};

const regionCodes: SafetyRegion = {
  "01": "Groningen",
  "02": "Friesland",
  "03": "Drenthe",
  "04": "Ijsselland",
  "05": "Twente",
  "06": "Noord- en Oost Gelderland",
  "07": "Gelderland-Midden",
  "08": "Gelderland-Zuid",
  "09": "Utrecht",
  "10": "Noord-Holland Noord",
  "11": "Zaanstreek-Waterland",
  "12": "Kennemerland",
  "13": "Amsterdam-Amstelland",
  "14": "Gooi en Vechtstreek",
  "15": "Haaglanden",
  "16": "Hollands Midden",
  "17": "Rotterdam-Rijnmond",
  "18": "Zuid-Holland Zuid",
  "19": "Zeeland",
  "20": "Midden- en West Brabant",
  "21": "Brabant Noord",
  "22": "Brabant Zuid-Oost",
  "23": "Limburg - Noord/Midden",
  "24": "Limburg-Zuid",
  "25": "Flevoland",
  "26": "Landelijk (LMAZ)",
};

const vehicleTypes: VehicleType = {
  "1": "Ambulance",
  "2": "Piket voertuig",
  "3": "Speciale ambulance of motor",
  "4": "BLS ambulance",
  "5": "Leiding, directie, logistiek",
  "6": "Internationale ambulance",
  "7": "Huisartsen",
  "8": "GHOR",
  "9": "MMT",
};

const specialCases: SpecialCases = {
  "3_01-09": "IC-lance",
  "3_10-19": "Babylance",
  "3_20-29": "Motoren",
  "3_30-39": "Ambulance Defensie",
  "3_40-59": "Rapid Responder",
  "8_01-19": "OvdG / CvdG",
  "8_20-29": "Ambuteam",
  "8_30-39": "SIGMA-team",
  "8_40-49": "HS-GHOR / HAc",
  "8_50-59": "RGF / RGFvD",
  "8_60-69": "Haakarmbak",
  "8_70-79": "Logistiek / overige dienstvoertuigen",
  "8_90-99": "VC / CGV",
  "9_01-89": "Grond gebonden team",
  "9_90-99": "Helikopter",
};

export function decodeVehicleNumber(ambulanceId: string) {
  if (!ambulanceId || ambulanceId.length < 4) {
    return { region: "", vehicle: "", unitNumber: "", specialCase: "" };
  }

  const regionCode = ambulanceId.substring(0, 2);
  const vehicleCode = ambulanceId.substring(2, 3);
  const unitNumber = parseInt(ambulanceId.substring(3, 5));

  const region = regionCodes[regionCode] || "";
  const vehicle = vehicleTypes[vehicleCode] || "";

  let specialCase = "";
  const key = `${vehicleCode}_${String(unitNumber).padStart(2, "0")}`;
  for (const bKey in specialCases) {
    if (bKey.startsWith(`${vehicleCode}_`)) {
      const [_, range] = bKey.split("_");
      const [min, max] = range.split("-").map(Number);

      if (unitNumber >= min && unitNumber <= max) {
        specialCase = specialCases[bKey];
        break;
      }
    }
  }

  return { region, vehicle, unitNumber, specialCase };
}
